import * as React from "react";
const SvgArrowLeftSmall20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 7,
        height: 10,
        fill: "black",
        viewBox: "0 0 7 10"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m6.414 2-3 3 3 3L5 9.414.586 5 5 .586 6.414 2Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowLeftSmall20Px;
